import React from 'react';
import { Headers, Header } from '@atlaskit/table-tree';

class THeader extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Headers>
        <Header width={95}>CELL NAME</Header>
        <Header width={95}>CELL ROW</Header>
        <Header width={235}>SQL TABLE COLUMN</Header>
        <Header width={500}>FORMULA / DATA</Header>
        <Header width={105} />
      </Headers>
    );
  }
}

export default THeader;
